import { Component, OnInit } from '@angular/core';
import { ToastService } from 'ng-uikit-pro-standard';

@Component({
  selector: 'app-modals',
  templateUrl: './modals.component.html',
  styleUrls: ['./modals.component.scss']
})
export class ModalsComponent implements OnInit {

  constructor(private toastrService: ToastService) { }

  showSuccess() {
    const options = { opacity: 1 };
    this.toastrService.success('Hello world!', 'Toastr success!', options);
  }
  
  showError() {
    const options = { opacity: 1 };
    this.toastrService.error('Error message', 'Toastr error!', options);
  }
  
  showInfo() {
    const options = { opacity: 1 };
    this.toastrService.info('Info message', 'Toastr info!', options);
  }
  
  showWarning() {
    const options = { opacity: 1 };
    this.toastrService.warning('Warnig message', 'Toastr warning!', options);
  }

  ngOnInit() {
  }

}
